import { useAppSelector } from "newui/store/hooks";

import {
	selectExecutiveView,
	selectIsExecutiveViewActive,
} from "newui/features/Auth/authSelectors";

interface UseExecutiveViewResult {
	executiveView: ReturnType<typeof selectExecutiveView>;
	isActive: boolean;
	isReadOnly: boolean;
	companyName: string | null;
	homeCompanyId: number | null;
}

export const useExecutiveView = (): UseExecutiveViewResult => {
	const executiveView = useAppSelector(selectExecutiveView);
	const isActive = useAppSelector(selectIsExecutiveViewActive);

	return {
		executiveView,
		isActive,
		isReadOnly: isActive,
		companyName: executiveView?.company_name ?? null,
		homeCompanyId: executiveView?.home_company_id ?? null,
	};
};
